import { CREATE_USER, UPDATE_USER, USERS_EXPORT_LOADING, USERS_EXPORT_SUCCESS, USERS_EXPORT_ERROR } from "../actions/types";
import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  error: "",
  loading: false,
  data: [],
  thisPage: 0,
  nextPage: 0,
  hasMore: true,
  count: 0,
  exportLoading: false,
};

const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CREATE_USER, (state, { payload }) => {
      state.data.unshift(payload);
      state.loading = false;
      state.error = false;
    })
    .addCase(UPDATE_USER, (state, { payload }) => {
      const index = state.data?.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
      state.error = false;
    })
    .addCase(USERS_EXPORT_LOADING, (state) => {
      state.exportLoading = true;
      state.error = "";
    })
    .addCase(USERS_EXPORT_SUCCESS, (state) => {
      state.exportLoading = false;
      state.error = "";
    })
    .addCase(USERS_EXPORT_ERROR, (state, { payload }) => {
      state.exportLoading = false;
      state.error = payload || "Export failed";
    });
});

export default userReducer;
